import { loader } from 'graphql.macro';

export const UPDATE_PORTAL_USER_DEFAULT_PAYMENT_FREQUENCY = loader(
  './mutation.graphql'
);

export * from './types';
